import { get } from 'lodash';
import { GuarantorLocationType } from '@lendi/core-constants';

import { FIELD_PATHS, YES_NO_OPTIONS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { BrokerInterviewsGuarantorEntityIndex } from '@funnels/types';

import { FunnelGrid, FunnelGridUnit } from '../../../Common';
import { RadioButtonsField, TextAreaField } from '../../../Fields';

export const OPTIONS = [
  { label: 'Lendi approved phone interview', value: GuarantorLocationType.lendiApprovedPhotoInterview },
  { label: 'Face to face', value: GuarantorLocationType.faceToFace },
];

interface InterviewLocationProps extends BrokerInterviewsGuarantorEntityIndex {
  hasUnderstandsEnglish?: boolean;
}

export const InterviewLocation = ({
  brokerInterviewsGuarantorIndex,
  hasUnderstandsEnglish,
}: InterviewLocationProps) => {
  const [formValues, , setFormValues] = useFormValues();
  const selectedLocation = get(
    formValues,
    FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_LOCATION(brokerInterviewsGuarantorIndex)
  );

  const isFaceToFace = selectedLocation === GuarantorLocationType.faceToFace;

  const handleOnLocationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newLocation = e.target.value;
    if (newLocation !== GuarantorLocationType.faceToFace) {
      setFormValues({
        [FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_LOCATION_DESCRIPTION(brokerInterviewsGuarantorIndex)]: undefined,
        [FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_UNDERSTANDS_ENGLISH(brokerInterviewsGuarantorIndex)]: undefined,
      });
    }
  };

  return (
    <FunnelGrid>
      <FunnelGrid mt="md" mb="lg">
        <FunnelGridUnit size={1 / 2}>Where did I interview the guarantor?</FunnelGridUnit>
        <FunnelGridUnit size={1 / 2}>
          <FunnelGridUnit mb="sm">
            <RadioButtonsField
              name={FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_LOCATION(brokerInterviewsGuarantorIndex)}
              size="sm"
              radios={OPTIONS}
              noVerticalSpace
              isBoxed={false}
              selectedValue={selectedLocation}
              onChange={handleOnLocationChange}
              isOptional
            />
          </FunnelGridUnit>
          <FunnelGridUnit mb="xxs">
            <TextAreaField
              label="Provide location description"
              isDisabled={!isFaceToFace}
              disableFailMessage={!isFaceToFace}
              rows={1}
              maxRows={2}
              name={FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_LOCATION_DESCRIPTION(brokerInterviewsGuarantorIndex)}
              isOptional
            />
          </FunnelGridUnit>
        </FunnelGridUnit>
      </FunnelGrid>
      {isFaceToFace && hasUnderstandsEnglish && (
        <FunnelGrid mb="lg">
          <FunnelGridUnit size={1 / 2}>
            If the interview is conducted face to face ask the Guarantor:
            <br />
            <br />
            As required by ANZ, can you read (out loud) the following sentence back to me: "I can read and speak English
            and understand what the Bank is asking of me".
          </FunnelGridUnit>
          <FunnelGridUnit size={1 / 2}>
            <RadioButtonsField
              name={FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_UNDERSTANDS_ENGLISH(brokerInterviewsGuarantorIndex)}
              radios={YES_NO_OPTIONS}
              size="sm"
              isBoxed={false}
              noVerticalSpace
              selectedValue={get(
                formValues,
                FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_UNDERSTANDS_ENGLISH(brokerInterviewsGuarantorIndex)
              )}
              isOptional
            />
          </FunnelGridUnit>
        </FunnelGrid>
      )}
    </FunnelGrid>
  );
};
